// extracted by mini-css-extract-plugin
export default {"carosel":"Carosel_carosel__vS5jS","heading":"Carosel_heading__AQ6Sx","subheading":"Carosel_subheading__x0esB","image":"Carosel_image__SXuGa"};